import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const Particles = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) return null;
  const particles = Array.from({
    length: 40
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-174">
      {particles.map((_, i) => {
      const size = Math.random() * 3 + 1;
      return <motion.div key={i} className="absolute rounded-full bg-white" style={{
        width: size,
        height: size,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`
      }} animate={{
        y: [0, -Math.random() * 300 - 100],
        x: [0, Math.random() * 100 - 50],
        opacity: [0, Math.random() * 0.5 + 0.2, 0]
      }} transition={{
        duration: Math.random() * 10 + 10,
        repeat: Infinity,
        ease: 'linear',
        delay: Math.random() * 5
      }} data-id="element-175" />;
    })}
    </div>;
};